import { RouteConfig } from 'vue-router';

import store from '@/store';
import { historyFilters } from '@/utils/history';
import { config } from '@/utils/config';

export const containerPointsRoute: RouteConfig = {
  path: 'containerPoints',
  component: () => import(/* webpackChunkName: "ContainerPoints" */ '@/views/main/ContainerPoints.vue'),
  name: 'containerPoints',
  beforeEnter(to, _from, next) {
    if (!config.modules.points) {
      return next({ name: 'home' });
    }
    return store.dispatch('containerPoints/list', historyFilters(to)).then(next);
  }
};
